/**
 * ENTSCHEIDUNGSSEITEN AUS DER EIGENEN, GESPIEGELTEN KOPIE (24.09.2026).
 *
 * `koordination/entscheidungen` wird alle 10 Minuten von Dev nach Partner gespiegelt;
 * jedes Haus liefert die Seiten unter seinem eigenen `/downloads/entscheidungen/` aus.
 * Rezepte nennen die Dev-Adresse. Seit Dev `/downloads` nur noch angemeldet ausliefert,
 * bekommt ein Browser im anderen Haus dort 401 — auch der Aufnahme-Browser des Partners
 * (`http://localhost:4005`, "Bühneninhalt leer, zu schmal oder horizontal abgeschnitten").
 * Bis heute galt die Umlenkung nur fuer https; sie gilt jetzt fuer jede http(s)-Seite.
 * Nur Pfade unter /downloads/entscheidungen/ der Dev-Adresse, nichts sonst.
 */
export const DEV_ENTSCHEIDUNGEN_URSPRUNG = 'http://100.121.161.109:4005';

export function entscheidungAusEigenerKopie(u: string, hier: { origin: string; protocol: string }): string {
  let parsed: URL;
  try { parsed = new URL(u); } catch { return u; }
  if (hier.protocol !== 'https:' && hier.protocol !== 'http:') return u;
  if (parsed.origin !== DEV_ENTSCHEIDUNGEN_URSPRUNG || parsed.origin === hier.origin) return u;
  if (!parsed.pathname.startsWith('/downloads/entscheidungen/')) return u;
  return hier.origin + parsed.pathname + parsed.search + parsed.hash;
}
